import React from "react";

export default function WhiteCircleCheck(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="17.667" height="17.667">
			<path
				d="M8.833 0a8.833 8.833 0 1 0 8.833 8.833A8.837 8.837 0 0 0 8.833 0ZM7.067 13.25 2.65 8.833 3.9 7.588l3.167 3.162 6.7-6.7 1.25 1.25Z"
				fill="#fff"
			/>
		</svg>
	);
}
